import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

export const useLanguageStore = create((set) => ({
  loading: true,
  error: null,
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error: error, loading: false }),
}));

export const useLanguage = () => {
  return useLanguageStore(
    useShallow((state) => ({
      isLangLoading: state.loading,
      langError: state.error,
    })),
  );
};
